module.exports = __webpack_public_path__ + "img/user-placeholder.d13b0919.png";